import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Depreciations from 'depreciations/components';
import DepreciationFormHandlers from 'depreciations/containers/DepreciationFormHandlers';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import {
  getIsSaving,
  getIsFetching,
  getEditing,
  getIsFetchingConfig,
} from 'depreciations/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

class DepreciationsFormContainer extends Component {
  render = () => (
    <DepreciationFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleRemoveYear,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        handleAddYear,
      }) => (
        <Depreciations.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          handleSubmit={handleSubmit}
          handleRemoveYear={handleRemoveYear}
          handleAddYear={handleAddYear}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          company={this.props.company}
          depreciation={this.props.depreciation}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  depreciation: getEditing(state),
  company: getCompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(DepreciationsFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/containers/DepreciationsFormContainer.js